






























































import {Component, Prop} from "vue-property-decorator";
import PrimaryPage from "@/layouts/primaryPage.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import SectionLayout from "@/layouts/sectionLayout.vue";
import PdfPreview from "@/components/pdfPreview.vue";
import articleOperation from "@/directives/articleOperation";
import basicPage from "@/layouts/basicPage.vue";
import ArticleOperationBar from "@/components/articleOperationBar.vue";
import keywordCard from "@/layouts/keywordCard.vue";

@Component({
  name: 'KBDetail',
  components: {ArticleOperationBar, PdfPreview, SectionLayout, PrimaryPage, keywordCard},
  directives: articleOperation
})
export default class KBDetail extends basicPage {
  @Prop({type: String, default: ''}) queryParams: string;

  docId: string = "";
  keywords: string = "";
  title: string = '';
  routeTokens: any = {};

  defRoutes = [{
    path: 'knowledgeBase',
    breadcrumbName: '知识库'
  }];

  record: any = {};
  //推荐关键字
  recommendedkeywords: any[] = [];
  id: string = '';

  isPDFPreview: boolean = false;

  //获取数据
  fetchRecord() {
    if (this.docId) {
      ajaxHelperInstance.get('web/doc/findById', {docId: this.docId}, undefined, this).then((res) => {
        let {status, data} = res;
        if (status === 200) {
          this.record = data.data || {};
          this.title = this.record.title;
          this.id = this.record.questionId;
          // debugger
          // this.fetchRecommendedkeywords(this.record.title);

          this.isPDFPreview = this.record.contentType === '文件'

          this.routeTokens = {"knowTitle": this.record.title};
        }
      });
    }
  }

  //获取推荐关键字（默认10条,模块: 1: 知识库; 2: Q&A; 空: 全部）
  fetchRecommendedkeywords(keywords: string = '') {
    let param = {moduleType: '1', keywords};
    ajaxHelperInstance.get('/web/global/query', param, undefined, this).then((res) => {
      let {status, data} = res;
      if (status === 200) {
        this.recommendedkeywords = data.data || [];
        console.log(this.recommendedkeywords);
      }
    });
  }

  //pdf文件预览
  handlePDFPreview(url: string) {
    this.isPDFPreview = true;
  }

  //关键字搜索
  handleSearch(keywords: string = '') {
    this.keywords = keywords;
    this.showList();
  }

  //显示列表页
  showList() {
    let queryParams = JSON.stringify({keywords: this.keywords, docTypeId: ''});
    this.switchRouting('knowledgeBase', {
      queryParams: queryParams
    });
  }

  //显示
  show() {
    this.fetchRecord();
  }

  mounted() {
    try {
      let obj = JSON.parse(this.queryParams);
      if (obj) {
        this.docId = obj.docId;
        this.keywords = obj.keywords;
        if (obj.skip !== false) {
          this.defRoutes = obj.skipPath ? [obj.skipPath] : [];
        }
      }
    } catch (e) {

    }
    this.show();
  }
}
